export interface ShiftDetailsPage {
  activeTabIndex: number;
}

export interface ShiftDetails {
  shiftDetailsPage: ShiftDetailsPage;
}

export interface TimeAndAttendanceState {
  shiftDetails: ShiftDetails
}

export function createInitialTimeAndAttendanceState(): TimeAndAttendanceState {
  return {
    shiftDetails: {
      shiftDetailsPage: {
        activeTabIndex: 0
      }
    }
  }
}